import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OficinaVirtualEmpresasIntegras.css';
import Footer from '../Footer/Footer';

const OficinaVirtualEmpresasIntegras = () => {
  const navigate = useNavigate();

  const irAlCatalogo = () => {
    navigate('/OficinaVirtualEmpresasIntegras/Catalogo');
  };

return (
  <>
    <div className="oficina-empresas-integras">
      <div className="oficina-empresas-contenido">

        <img
          src="/assets/imgs/EmpresasIntegrasHidalgo/empresas-integras.png"
          alt="Empresas Íntegras Hidalgo"
          className="logo-empresas-integras"
        />

        <button
          className="btn-ingresar"
          onClick={irAlCatalogo}
        >
          Ingresar
        </button>

      </div>
    </div>

    {/* <Footer /> */}
  </>
);
};

export default OficinaVirtualEmpresasIntegras;